import { QueriesContext, useQueries } from "@ngt/opms";
import { FC, PropsWithChildren } from "react";

export interface IAllQueriesProviderProps extends PropsWithChildren {

}

export const AllQueriesProvider: FC<IAllQueriesProviderProps> = ({
    children
}) => {
    const queriesContext = useQueries();
    return (
        <QueriesContext.Provider value={queriesContext}>
            {children}
        </QueriesContext.Provider>
    );
} 

export default AllQueriesProvider;